// app/src/envProbe.ts
//
// Purpose: make it trivial to audit Vite env injection and runtime overrides
// from inside DevTools WITHOUT using import.meta directly in the console.

export const envProbe = (() => {
  const e = (import.meta as any).env || {};

  return {
    // Core Vite values
    MODE: e.MODE,
    DEV: e.DEV,
    PROD: e.PROD,
    BASE_URL: e.BASE_URL,

    // Your app's env
    VITE_SOLANA_CLUSTER: e.VITE_SOLANA_CLUSTER,
    VITE_SOLANA_RPC: e.VITE_SOLANA_RPC,
    VITE_SOLANA_ENDPOINT: e.VITE_SOLANA_ENDPOINT,
    VITE_PROGRAM_ID: e.VITE_PROGRAM_ID,
    VITE_WEARE_SUSU_PROGRAM_ID: e.VITE_WEARE_SUSU_PROGRAM_ID,
    VITE_LOG_LEVEL: e.VITE_LOG_LEVEL,

    // Runtime config visibility (non-sensitive)
    RUNTIME_CONFIG_PRESENT: typeof window !== "undefined" && !!(window as any).__WEARE_SUSU_RUNTIME_CONFIG__,
  };
})();
